export default "__VITE_ASSET__CfeiAtlP__"